import Icon from './Icon.jsx';
import { scrollToId } from '../hooks/useActiveSection.js';

const go = (e, id) => {
  e.preventDefault();
  scrollToId(id);
};

export default function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-blob b1" />
      <div className="hero-blob b2" />
      <div className="hero-inner">
        <div className="hero-text">
          <div className="hero-badge">
            <span className="pulse-dot" />
            Welcoming Patients at 2 Locations
          </div>
          <h1 className="hero-title">
            Kanaga<br />
            <em>Dental Clinic</em>
          </h1>
          <p className="hero-tagline">Your Smile, Our Priority</p>
          <p className="hero-desc">
            Experience gentle, personalized dental care in a warm and welcoming environment.
            We're here to help you and your family achieve lasting oral health and confident smiles.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary" onClick={(e) => go(e, 'contact')}>
              <Icon name="mail" size={16} width={2.2} />
              Contact Us
            </a>
            <a href="#services" className="btn btn-outline" onClick={(e) => go(e, 'services')}>
              Explore Services
            </a>
          </div>
          <div className="hero-trust">
            <div className="trust-item">
              <strong>2</strong>
              <span>Branches</span>
            </div>
            <div className="trust-sep" />
            <div className="trust-item">
              <strong>2</strong>
              <span>Doctors</span>
            </div>
            <div className="trust-sep" />
            <div className="trust-item">
              <strong>100%</strong>
              <span>Dedicated</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-float f1">
            <span>😊</span> Comfortable Visits
          </div>
          <div className="hero-card">
            <div className="hero-card-stripe" />
            <div className="hero-card-body">
              <div className="hc-tooth-wrap">
                <svg viewBox="0 0 64 72" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path
                    d="M32 4C19 4 10 12 10 21c0 4.5 2 8 2.8 13 .9 7 1.8 20 7.2 20 2.5 0 4-2.5 5.5-5.5 1.2 2.5 2.8 5 5.5 6 2.2.8 3.5-2 4.5-5.5 1.5 3.5 3 6 5.5 6 5.4 0 6.3-13 7.2-20C49 29 54 25 54 21c0-9-10-17-22-17z"
                    stroke="#D5175F"
                    strokeWidth="2"
                    fill="rgba(213,23,95,0.08)"
                  />
                </svg>
              </div>
              <h3>
                Your Dental Health
                <br />
                Matters to Us
              </h3>
              <p>Caring for smiles across 2 convenient locations</p>
              <div className="hc-stats">
                <div className="hc-stat">
                  <strong>2</strong>
                  <span>Branches</span>
                </div>
                <div className="hc-divider" />
                <div className="hc-stat">
                  <strong>2</strong>
                  <span>Doctors</span>
                </div>
                <div className="hc-divider" />
                <div className="hc-stat">
                  <strong>100%</strong>
                  <span>Care</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-float f2" style={{ animationDelay: '-1.5s' }}>
            <span>✨</span> Healthy Smiles
          </div>
        </div>
      </div>
    </section>
  );
}
